(() => {
  if (customElements.get('healthy-product-discovery')) return;
  class HealthyProductDiscovery extends HTMLElement {
    connectedCallback() {
      if (this.track) return;
      this.track = this.querySelector('[data-hl-discovery-track]');
      this.previous = this.querySelector('[data-hl-discovery-prev]');
      this.next = this.querySelector('[data-hl-discovery-next]');
      this.controls = this.querySelector('[data-hl-discovery-controls]');
      if (!this.track || !this.previous || !this.next) return;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.onPrevious = () => this.move(-1);
      this.onNext = () => this.move(1);
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      this.onKey = (event) => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      };
      this.previous.addEventListener('click', this.onPrevious);
      this.next.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, {passive: true});
      this.track.addEventListener('keydown', this.onKey);
      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
      } else {
        window.addEventListener('resize', this.onScroll);
      }
      this.update();
    }
    move(direction) {
      const first = this.track.querySelector('[data-hl-discovery-item]');
      if (!first) return;
      const style = getComputedStyle(this.track);
      const gap = parseFloat(style.columnGap) || 0;
      const sign = style.direction === 'rtl' ? -1 : 1;
      this.track.scrollBy({left: direction * sign * (first.getBoundingClientRect().width + gap), behavior: this.reduced.matches ? 'auto' : 'smooth'});
    }
    update() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const position = Math.abs(this.track.scrollLeft);
      const overflow = maximum > 1;
      this.previous.disabled = !overflow || position <= 1;
      this.next.disabled = !overflow || position >= maximum - 1;
      if (this.controls) this.controls.hidden = !overflow;
    }
    disconnectedCallback() {
      this.resize?.disconnect();
      window.removeEventListener('resize', this.onScroll);
      if (this.frame) cancelAnimationFrame(this.frame);
      this.previous?.removeEventListener('click', this.onPrevious);
      this.next?.removeEventListener('click', this.onNext);
      this.track?.removeEventListener('scroll', this.onScroll);
      this.track?.removeEventListener('keydown', this.onKey);
      this.track = null;
      this.frame = null;
    }
  }
  customElements.define('healthy-product-discovery', HealthyProductDiscovery);
})();
